import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { LineChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/line-chart';
import { BarChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/bar-chart';
import { AreaChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/area-chart';
import { RadarChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/radar-chart';
import { PieChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/pie-chart';
import { DoughnutChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/doughnut-chart';
import { ScatterChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/scatter-chart';
import { BubbleChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/bubble-chart';
import { StockChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/stock-chart';
import { OfPieChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/of-pie-chart';
import type { BaseSubChartProperty } from './base-sub-chart';
import type {
    ISubChartModel,
    ILineChart,
    IBarChart,
    IAreaChart,
    IRadarChart,
    IPieChart,
    IDoughnutChart,
    IScatterChart,
    IBubbleChart, IStockChart, IOfPieChart,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

// eslint-disable-next-line complexity
export function createSubChartProperty(subChartModel: ISubChartModel): BaseSubChartProperty | undefined {
    const subChartType = subChartModel.type;

    switch (subChartType) {
        case SubChartType.BarChart:
            return new BarChartProperty(subChartModel as IBarChart, subChartModel.getContext());
        case SubChartType.LineChart:
            return new LineChartProperty(subChartModel as ILineChart, subChartModel.getContext());
        case SubChartType.AreaChart:
            return new AreaChartProperty(subChartModel as IAreaChart, subChartModel.getContext());
        case SubChartType.RadarChart:
            return new RadarChartProperty(subChartModel as IRadarChart, subChartModel.getContext());
        case SubChartType.PieChart:
            return new PieChartProperty(subChartModel as IPieChart, subChartModel.getContext());
        case SubChartType.DoughnutChart:
            return new DoughnutChartProperty(subChartModel as IDoughnutChart, subChartModel.getContext());
        case SubChartType.ScatterChart:
            return new ScatterChartProperty(subChartModel as IScatterChart, subChartModel.getContext());
        case SubChartType.BubbleChart:
            return new BubbleChartProperty(subChartModel as IBubbleChart, subChartModel.getContext());
        case SubChartType.StockChart:
            return new StockChartProperty(subChartModel as IStockChart, subChartModel.getContext());
        case SubChartType.OfPieChart:
            return new OfPieChartProperty(subChartModel as IOfPieChart, subChartModel.getContext());
    }
}
